import React, { useRef } from 'react';
import numeral from 'numeral';

import { ZoneSelectProps } from '../../components/cart/zone-select';
import { IZone } from '../../custom/classes/production';
import { sumPrices } from '../../helpers/pricing-helpers';
import { A11yDialog } from 'react-a11y-dialog';
import A11yDialogInstance from 'a11y-dialog';

const ZoneSelectView: React.StatelessComponent<ZoneSelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        props.selectZone(props.itemId, selectedValue);
    }

    const zoneImageModal = useRef<A11yDialogInstance>();
    const modalClasses = {
        container: 'modal-container ace-subs-zone-modal', overlay: 'modal-overlay', dialog: 'dialog-content', title: 'visually-hidden', closeButton: 'dialog-close'
    };

    return (
        <div className="space-top-lg stack-sm">


            <div>
                {
                    props.requiresPriceTypeSelection ?
                        (
                            props.showPriceTypeError
                                ?
                                <p className="error-message">
                                    <a href="#quantitySelect">
                                        {props.missingPriceTypeSelectionMessage}
                                    </a>
                                </p>
                                : null)
                        :
                        (
                            props.selectedZone != null ?
                                <div className="flex-between">
                                    <span className="bold">{props.selectedZone.zone.description}</span>
                                    <span>{numeral(sumPrices(props.selectedZone, props.selectedPriceTypeQuantities).priceSum).format('$0,0.00')}</span>
                                </div>
                                :
                                (
                                    !props.hideZoneDropdown &&
                                    <div className="stack-xs">
                                        <label htmlFor={props.itemId + "-quantity"}>
                                            {props.selectAZoneLabel}
                                        </label>
                                        <select name={props.itemId + "-quantity"} id={props.itemId + "-quantity"} onChange={(evt) => {
                                            onChange(evt);
                                        }} value={props.selectedZone?.zone.id ?? 0}>
                                            <option key={0} value={0}>
                                                {props.selectAZoneDropdownDefaultValue}
                                            </option>
                                            {
                                                props.zones.sort((a, b) => { return a.zone.rank - b.zone.rank; }).map(zone => {
                                                    let { priceSum, foundAllPriceTypes } = sumPrices(zone, props.selectedPriceTypeQuantities);

                                                    const price = numeral(priceSum).format('$0,0.00');

                                                    const optionDisabled = !(zone.availableCount > Array.from(props.selectedPriceTypeQuantities.values()).reduce((total, num) => total + num, 0) && foundAllPriceTypes);

                                                    const optionDisplay = `${zone.zone.description} - ${optionDisabled ? "Not Available" : price}`;


                                                    return (<option disabled={optionDisabled} key={zone.zone.id} value={zone.zone.id}>{optionDisplay}</option>)
                                                })
                                            }
                                        </select>
                                    </div>
                                )
                        )
                }
            </div>



            {
                props.selectedZone == null && props.venueZoneMapImageUrl != null && !props.hideZoneDropdown ?
                    <div className="ace-subs-zone-modal-trigger">
                        <button type="button" className="hyperlink un-btn" onClick={() => zoneImageModal.current?.show()}>
                            View Zone Map
                        </button>
                    </div>
                    : null
            }
            <A11yDialog
                id="zone_modal"
                dialogRef={instance => (zoneImageModal.current = (instance as A11yDialogInstance))}
                title="Zone Map"
                classNames={modalClasses}
                closeButtonLabel="Close">

                <div className="ace-flex-zone-map"><img src={props.venueZoneMapImageUrl} alt={`${props.venueName} zone map`} /></div>

            </A11yDialog>


        </div>
    );
}

export default ZoneSelectView;


